// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import Close from "@guestsupply/XDL/Icons/Close";
import MenuBack from "@guestsupply/XDL/Icons/MenuBack";
import { xBaseTheme } from "@guestsupply/XDL/types";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        headerColor: "common.white",
        bodyColor: "common.white",
        backIconProps: {
            src: MenuBack,
            size: 11,
            color: "text.link",
            css: css`
                transform: rotate(90deg);
            `,
        },
        childTypographyProps: {
            css: css`
                display: block;
                word-wrap: break-word;
                width: 100%;
                span {
                    font-size: 15px !important;
                }
            `,
        },
        closeIconProps: {
            src: Close,
            size: 14,
            css: css`
                margin-right: 7px;
            `,
        },
        panelRowProps: {
            ...PanelMenuDefaultProps?.panelRowProps,
            moreIconProps: {
                src: CaretRight,
                size: 10,
                css: css`
                    color: ${getColor("text.link")};
                `,
            },
        },
        backIconWrapperProps: {
            css: css`
                display: flex;
                align-items: center;
                gap: 8px;
                width: 100%;
                padding: 14px 0;
                border-bottom: 1px solid ${getColor("common.border")};
            `,
        },
        backIconTypography: {
            color: "text.link",
            size: 12,
            weight: "bold",
        },
        menuTextProps: {
            css: css`
                &&& {
                    color: ${getColor("text.main")};
                    font-size: 18px;
                    font-weight: bold;
                    text-transform: capitalize;
                }
            `,
        },
        menuTitleProps: {
            typographyProps: {
                size: 14,
                weight: "500",
                css: css`
                    &&& {
                        color: ${getColor("secondary")};
                        padding: 6px 16px;
                        display: block;
                    }
                `,
            },
        },
    },
} as xBaseTheme["panelMenu"];
